<!-- START: Mobile bottom nav -->
<div
  class="yt-m-bottom-nav d-flex flex-row align-items-center justify-content-around"
>
  <span class="yt-m-tab placeholder"></span>
  <span class="yt-m-tab placeholder"></span>
  <i class="bi bi-plus-circle"></i>
  <span class="yt-m-tab placeholder"></span>
  <span class="yt-m-tab placeholder"></span>
</div>
<!-- END: Mobile bottom nav -->
